import { Badge } from '@/components/ui/badge';

/**
 * Badge di stato per run e casi demo.
 *
 * Usa solo i token di stile gia' esistenti (success/warning/danger/info/muted)
 * e il componente `Badge` condiviso: nessun nuovo design system. Uno status
 * sconosciuto non rompe la pagina, ricade su un badge neutro con il valore
 * grezzo.
 */

interface DemoRunStatusProps {
  status: string | null | undefined;
  className?: string;
}

interface StatusStyle {
  label: string;
  className: string;
}

const STATUS_STYLES: Record<string, StatusStyle> = {
  passed: {
    label: 'Passato',
    className: 'bg-success/10 text-success border-success/20',
  },
  blocked: {
    label: 'Bloccato',
    className: 'bg-warning/10 text-warning border-warning/20',
  },
  failed: {
    label: 'Fallito',
    className: 'bg-danger/10 text-danger border-danger/20',
  },
  running: {
    label: 'In corso',
    className: 'bg-info/10 text-info border-info/20',
  },
  pending: {
    label: 'In attesa',
    className: 'bg-muted text-muted-foreground border-border',
  },
};

const FALLBACK_STYLE: StatusStyle = {
  label: 'Sconosciuto',
  className: 'bg-muted text-muted-foreground border-border',
};

export function DemoRunStatus({ status, className }: DemoRunStatusProps) {
  const config = (status && STATUS_STYLES[status]) || FALLBACK_STYLE;
  const label = status && !STATUS_STYLES[status] ? status : config.label;

  return (
    <Badge
      variant="outline"
      data-testid={`demo-status-${status ?? 'unknown'}`}
      className={`${config.className} ${className ?? ''}`}
    >
      {label}
    </Badge>
  );
}
